export const getPrograms = (state) => state.programs
export const getCurrentProgram = (state) => state.currentProgram
export const getEarningTypes = (state) => state.earningTypes
export const getRewardTypes = (state) => state.rewardTypes
export const getMyShops = (state) => state.myShops
export const getSimpleProducts = (state) => state.simpleProducts
export const getPosMember = (state) => state.posMember
export const getPosAvailableRewards = (state) => state.posAvailableRewards
export const getMembers = (state) => state.members
export const getMemberStats = (state) => state.memberStats
export const getCurrentMember = (state) => state.currentMember
export const getCurrentMemberTransactions = (state) => state.currentMemberTransactions
